import { Circle } from 'rc-progress';
import React, { useEffect, useState } from 'react';

import './TotalLoggedInEmployee.css';
import axiosInstance from '../../../utils/axiosInstance'; // Use axiosInstance

export const TotalLoggedInEmployee = ({ adminIds, empRole }) => {
    const [activeEmployees, setActiveEmployees] = useState(0);
    const [totalEmployees, setTotalEmployees] = useState(0);

    useEffect(() => {
        const fetchEmployeesData = async () => {
            try {
                // Fetch total count of employees
                const employeesResponse = await axiosInstance.get(`/admin/employees`);

                let filteredEmployees;
                if (empRole === 'SuperAdmin') {
                    // If the role is SuperAdmin, do not filter by adminIds
                    filteredEmployees = employeesResponse.data;
                } else {
                    // Filter employees based on adminIds
                    filteredEmployees = employeesResponse.data.filter(employee => adminIds.includes(employee.emp_id));
                }
                const totalEmployeesCount = filteredEmployees.length;
                setTotalEmployees(totalEmployeesCount);

                // Fetch employee attendance data for the current date
                const currentDate = new Date().toISOString().split('T')[0]; // Get current date in "YYYY-MM-DD" format
                const attendanceResponse = await axiosInstance.get(`/admin/employeesAttendance?date=${currentDate}`);
                const attendanceData = attendanceResponse.data;

                let filteredAttendance;
                if (empRole === 'SuperAdmin') {
                    // If the role is SuperAdmin, do not filter by adminIds
                    filteredAttendance = attendanceData.filter(record => record.attendance === 'p');
                } else {
                    // Filter attendance data based on adminIds and attendance status 'p'
                    filteredAttendance = attendanceData.filter(
                        record => adminIds.includes(record.emp_id) && record.attendance === 'p'
                    );
                }

                // Count the number of unique employees with attendance records for the current date
                const activeEmployeesCount = new Set(filteredAttendance.map(item => item.emp_id)).size;
                setActiveEmployees(activeEmployeesCount);
            } catch (error) {
                console.error('Error fetching employee data:', error);
            }
        };

        fetchEmployeesData();
    }, [adminIds, empRole]); // Re-fetch data if adminIds or empRole change

    return (
        <div className='circleBody'>
            <Circle percent={(activeEmployees / totalEmployees) * 100} strokeColor={'#5CBB60'} strokeWidth={4} trailWidth={4} />
            <div className='text-overlay'><span>{activeEmployees}</span>/{totalEmployees}</div>
        </div>
    );
};
